import axios from 'axios';

const getComprasProdutos = params => axios.get('/compras/produtos', {
  params,
});

export default {
  getComprasProdutos,
};
